module.exports = __webpack_public_path__ + "static/media/Protagonist Logo Head_White.e67c7f02.svg";